export default class MapLocationDefinition {
    constructor(id, instanceName, imageId) {
        this._id = id;
        this._instanceName = instanceName;
        this._imageId = imageId;
    }

    get id() {
        return this._id;
    }

    get instanceName() {
        return this._instanceName;
    }

    get imageId() {
        return this._imageId;
    }
}